
export const GRID_DEFAULT_PAGINATION_MODEL = {
    page: 0,
    pageSize: 10,
}